import { GL_Category } from '../models/GL_Category';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()

export class ReportService {
    private readonly ReportEndpoint = '/api';
    constructor(private http: HttpClient) { }
  getStudentFinanceReport(studentID: string) {
    return this.http.get(this.ReportEndpoint + `/Report/GetStudentFinanceReport/${studentID}`);
  }
  getStudentList(studentID: string, firstName: string, lastName: string, fatherName: string, semester: string, department: string, year: string, shift: string, season: string) {
    return this.http.get(this.ReportEndpoint + `/Report/GetStudentList?studentID=${studentID}&firstName=${firstName}&lastName=${lastName}&fatherName=${fatherName}&semester=${semester}&department=${department}&year=${year}&shift=${shift}&season=${season}`);  // report
  }
  getSumMoney(semester: string, year: string, shift: string, season: string) {
    return this.http.get(this.ReportEndpoint + `/Report/GetSumMoney?semester=${semester}&year=${year}&shift=${shift}&season=${season}`);  // report
  }
  getSemesters(studentID: string) {
    return this.http.get(this.ReportEndpoint + `/Report/GetSemesterForFinanceReport/${studentID}`);
  }
    getStudentDetails(studentID: string) {
      return this.http.get(this.ReportEndpoint + `/Report/GetStudentDetails/${studentID}`);
    }
  TrialBalance(asOfDate: string , branchId:number) {
    return this.http.get(this.ReportEndpoint + '/Report/Get_Trial_Balance?As_Of_Date=' + asOfDate + `&branchId=${branchId}`);
    }

    IncomeStatement(fromDate: string,toDate:string, flg_income_expense, branchId:number, userId :string) {
      return this.http.get(this.ReportEndpoint + '/Report/IncomeStatement?FromDate='
        + fromDate + '&ToDate=' + toDate + '&flg_income_or_expense=' + flg_income_expense + `&branchId=${branchId}` + `&userId=${userId}`);
  }

  IncomeStatementAccount(fromDate: string, toDate: string, flg_income_expense, branchId: number, userId: string, masterAcc: string, childAcc: string) {
    return this.http.get(this.ReportEndpoint + '/Report/Get_IncomeStatement_Account?FromDate='
      + fromDate + '&ToDate=' + toDate + '&flg_income_or_expense=' + flg_income_expense + `&branchId=${branchId}` + `&userId=${userId}` + `&masterAcc=${masterAcc}` + `&childAcc=${childAcc}`);
  }

  BalanceSheet(gl_category: string, branchId: number) {
    return this.http.get(this.ReportEndpoint + '/Report/BalanceSheet?gl_category=' + gl_category + `&branchId=${branchId}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/Acc_ReportService.ts